export default __webpack_public_path__ + "static/media/640_dummy2016-coach02-mobile-de.51a0ad48.png";